import React from 'react'

import { connect } from 'react-redux'
import throttle from 'lodash/throttle'

import { reverse } from 'routes'

import { initFetch, fetchClientsOnSearch, fetchNextPage } from 'scenes/Clients/actions'

import BasePureComponent from 'utils/BasePureComponent'
import Breadcrumb from 'components/Breadcrumb'
import SearchInput from 'components/SearchInput'
import A from 'components/A'

import ClientsList from 'scenes/Clients/components/List'
import LocationFilter from 'scenes/Clients/components/LocationFilter'

import './style.scss'


export class Clients extends BasePureComponent {

  constructor(props) {
    super(props);

    this._bind('_onScroll')
  }

  componentWillMount() {
    this.props.initialFetch()
  }

  componentDidMount() {
    window.onscroll = throttle(this._onScroll, 100)
  }

  componentWillUnmount() {
    window.onscroll = null
  }

  _onScroll(e) {
    const documentElement = this.wrapper
    const scrollPosition = window.pageYOffset || documentElement.scrollTop
    const documentHeight = documentElement.scrollHeight
    const diffToFetch = documentHeight / 4
    if (documentHeight - scrollPosition < diffToFetch){
      // fetch next results
      if (!this.props.isFetching && this.props.pagination.next) {
        this.props.fetchNextPage()
      }
    }
  }

  render() {
    return (
      <section id="Clients">
        <Breadcrumb levels={this.props.breadcrumb} />
        <div className="Clients__section-header d-flex align-items-center">
          <h3 className="scene-title  cl-achromatic-c-color">Clientes</h3>
          <A to={reverse('clients:new')} iconName="person_add">Agregar nuevo cliente</A>
        </div>
        <div className="Clients__wrapper row">
          <div className="col-md-3">
            <LocationFilter />
          </div>
          <div className="col-md-9">
            <SearchInput
              autoFocus
              onChange={this.props.onSearchChange}
              value={this.props.searchTerm}
              placeholder="Buscar cliente por: nombre(s), apellidos, correo electrónico, número telefónico o RFC"
            />
            <div className="Clients__wrapper-list" ref={(div) => this.wrapper = div}>
              <ClientsList />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    searchTerm: state.clients.get('searchTerm'),
    isFetching: state.clients.get('isFetching'),
    pagination: state.clients.get('pagination').toJS(),
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    initialFetch: () => dispatch(initFetch()),
    fetchNextPage: () => dispatch(fetchNextPage()),
    onSearchChange: (evt) => dispatch(fetchClientsOnSearch(evt.target.value)),
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Clients)



// WEBPACK FOOTER //
// ./src/scenes/Clients/index.js